import styled from "styled-components";
import { NewSelect, NewTextField, NewTypography } from "@bca/ui-library";

export const StyledContactInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 2rem;
`;

export const StyledTitle = styled(NewTypography)`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: ${(props) => (props.isMobile ? "22px" : "32px")};
  line-height: 29px;
  margin-top: 3.75rem;
  margin-bottom: 2.8rem;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 1rem;
`;

export const StyledInputGroup = styled.div`
  display: flex;
  column-gap: 2.88rem;
`;

export const StyledInput = styled(NewTextField)`
  width: 100%;
`;

export const StyledNewSelect = styled(NewSelect)`
  width: 7.5rem;
  font-size: 3.28rem;
`;
